module.exports = __webpack_public_path__ + "static/media/phone-slash.fe7c5e5d.svg";